
import { defineComponent } from '@nuxtjs/composition-api';
import AutocompleteDropdownV2 from '@/components/common/AutocompleteDropdownV2.vue';
import PlusIcon from '@/assets/svg/plus.vue.svg';
import EducationHistoryUniversitiesQuery from '@/components/partials/public-portfolio/PublicPortfolioEducationHistory/apollo/EducationHistoryUniversities.query';
import EducationHistoryCreateUniversityMutation from '@/components/partials/public-portfolio/PublicPortfolioEducationHistory/apollo/EducationHistoryCreateUniversity.mutation';
import type { University } from '@/types/graphql';

type Item = { label: string; value: string };

export default defineComponent({
  name: 'PublicPortfolioEducationHistoryUniversity',
  components: {
    AutocompleteDropdownV2,
    PlusIcon,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Object,
      default: () => ({ name: '' }),
    },
  },
  apollo: {
    cities: {
      query: EducationHistoryUniversitiesQuery,
      variables() {
        return {
          search: this.query,
        };
      },
      update(data) {
        this.items = data.universities.nodes.map((item: University) => item);
      },
      skip() {
        return !this.query || !this.changed;
      },
      debounce: 500,
      fetchPolicy: 'network-only',
    },
  },
  data(): { query: string; items: Array<University>; changed: boolean } {
    return {
      query: this.value.name,
      items: [],
      changed: false,
    };
  },
  computed: {
    canAddNew() {
      return Boolean(this.query) && this.changed;
    },
  },
  methods: {
    handleQuery({ value: query }: Item) {
      if (query !== this.query) {
        this.changed = true;
        this.query = query;
      }
    },
    async handlePush(value: University) {
      if (value.id) {
        this.$emit('input', value);
      } else {
        const {
          data: { createCustomUniversity: newUniversity },
        } = await this.$apollo.mutate({
          mutation: EducationHistoryCreateUniversityMutation,
          variables: {
            input: { name: value.name },
          },
        });
        this.$emit('input', newUniversity);
      }
    },
  },
});
